import { FormGroup } from "@angular/forms";
import { debounceTime, filter, finalize, switchMap, takeUntil} from 'rxjs/operators';
import {BehaviorSubject, Observable, of, Subject} from 'rxjs';
import {Component, OnDestroy, OnInit} from "@angular/core";
import {ConditionSearchModel, PagingModel, SortSearchModel} from "../vss-ui.model";
import {Ultilities} from "../extensions/ultilities";
import { NzMessageService } from "ng-zorro-antd/message";
import { VssApiService } from "../services/vss-api.service";

@Component({
  template: ''
})
export abstract class BaseListComponent implements OnDestroy, OnInit{
  destroy$: Subject<void> = new Subject<void>()

  /***
   * filterData: sẽ truyền vào payload 1 obj
   * conditions: sẽ truyền 1 lsCondition vào payload
   * all: cả 2
   *
   * default value: conditions
   */
  searchType: 'filterData' | 'conditions' | 'all' = 'conditions'
  delaySearchTime = 300 //ms
  loadingTable = true
  listOfData: any[] = [];
  displayData: readonly any[] = [];
  paging: PagingModel = {
    pageIndex: 1,
    pageSize: 10,
    totalElements: 0,
    totalPages: 1
  };
  allChecked = false;
  indeterminate = false;
  editCache: { [key: string]: { edit: boolean; data: any } } = {};
  myForm!: FormGroup;
  controArrName!: string;
  params: any = {};
  /**
   * conditions: dành cho các api sử dụng param isCondition để lọc dữ liệu.
   * sortField: dành cho các api sử dụng param sortField để sắp xếp dữ liệu
   * filterData: Dạng filter base cho các api filter thông thường
   */
  searchBind$: BehaviorSubject<{conditions: ConditionSearchModel[], sortField: SortSearchModel[], filterData: any}> =
    new BehaviorSubject<{conditions: ConditionSearchModel[], sortField: SortSearchModel[], filterData: any}>({conditions: [], sortField: [], filterData: {}})
  isSearchBindStart = true

  get myFormValues() {
    return this.myForm.getRawValue()
  }
  constructor(
    // private loadingService: LoadingService,
    private apiServices?: VssApiService,
    private messageServices?: NzMessageService,
    ) {
  }

  ngOnInit() {
    this.loadingTable = false
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
    this.destroy$.unsubscribe()
  }


  /**
   * Sử dụng để khởi tạo sự kiện cho searchBind$
   * Cần thêm hàm này vào ngOnInt().
   * exp:
   * ngOnInit() {
   *       this.setupStreamSearch()
   * }
   */
  setupStreamSearch() {
    this.searchBind$.pipe(
      takeUntil(this.destroy$),
      debounceTime(this.delaySearchTime),
      filter(() => {
        if(!this.isSearchBindStart) {
          this.isSearchBindStart = true
          return false
        }
        return true
      }),
      switchMap(
        ({conditions, sortField, filterData}) => {
          this.params.page = this.paging.pageIndex;
          this.params.size = this.paging.pageSize;
          let payload: any = {
            page: this.params.page,
            size: this.params.size,
            sortField: sortField
          }
          if(['conditions', 'all'].includes(this.searchType)) {
            payload.lsCondition = conditions || []
          }
          if(['filterData', 'all'].includes(this.searchType)) {
            payload = {
              ...payload,
              ...filterData
            }
          }
          // this.listOfData = []
          // this.paging.totalElements = 0;
          // this.paging.totalPages = 0;
          this.setLoading(true)
          return this.apiSearch(payload).pipe(finalize(() => this.setLoading(false)))
        }
      )
    ).subscribe()
  }

  convertToSnakeCase(str: any) {
    if (!str) return ''
    return str.replace(/([A-Z])/g, '_$1').toLowerCase();
  }

  /**
   * Sử dụng để bắt sự kiện chuyển trang, đi cùng với streamSearch
   * Cần thêm hàm này vào sự kiện changePage của phần phân trang trong template
   */
  onPageIndexChange(event: any){
    this.paging.pageIndex = event
    this.searchBind$.next(this.searchBind$.value)
  }

  /**
   * Sử dụng để bắt sự kiện chuyển độ lớn của 1 trang, đi cùng với streamSearch
   * Cần thêm hàm này vào sự kiện changePageSize của phần phân trang trong template (Nếu có hành động thay đổi pageSize)
   */
  onPageSizeChange(event: any){
    this.paging.pageSize = event;
    this.onPageIndexChange(1)
  }


  /**
   * Sử dụng để setup api search.
   * override hàm này để thay đổi api search cho stream search
   * dùng tap from 'rxjs/operators' để thực hiện các công việc lưu gán listOfData, paging.totalElements, paging.page
   * example:
   * apiSearch(payload: any): Observable<any> {
   *     return this.apiService.getDataList(payload)
   *       .pipe(
   *         tap(
   *           x => {
   *             if (x.data && x.data) {
   *                 this.listOfData = x.data?.content
   *                 this.paging.totalElements = x?.data?.totalElements || 0;
   *                 this.paging.totalPages = x.data.totalPages;
   *               }
   *           }
   *         ),
   *         catchError(
   *           error => {
   *              // bắt lỗi tại đây
   *             return EMPTY
   *           }
   *         )
   *       )
   *   }
   *   @param payload: {
   *             page: number,
   *             size: number,
   *             lsCondition: conditions || [],
   *             sortField: sortField || []
   *           }
   *
   *   @return Observable<any>
   */
  apiSearch(payload: any): Observable<any> {
    return of()
  }

  /**
   * Custom lại loading khi search bằng cách override lại hàm này
   * @param value: boolean
   */
  setLoading(value: boolean): void {
    this.loadingTable = value
  }

  /***
   * @param event: {
   * force: boolean,
   * filter: any,
   * conditionsSearch: ConditionSearchModel[],
   * sortField: SortSearchModel[]
   * }
   */
  onFilterInTable(event: any) {
    if(Ultilities.compareObject(this.searchBind$.value.filterData, event?.filter || {}) || event?.force) {
      this.paging.pageIndex = 1
      this.searchBind$.next({
        conditions: event?.conditionsSearch || [],
        sortField: event?.sortField || [],
        filterData: event.filter
      })
    }
  }

  currentPageDataChange($event: readonly any[]): void {
    this.displayData = $event;
    this.refreshStatus();
  }

  clickSearch(page = 1) {
    this.paging.pageIndex = page;
    this.searchBind$.next(this.searchBind$.value);
  }

  getChangePagination(page = 1) {
    this.clickSearch(page);
  }
  checkAll(value: boolean): void {
    this.displayData.forEach(data => {
      if (!data.disabled) {
        data.checked = value;
      }
    });
    this.refreshStatus();
  }

  refreshStatus(): void {
    const validData = this.displayData.filter(value => !value.disabled);
    const allChecked = validData.length > 0 && validData.every(value => value.checked === true)
      || (!!this.displayData?.length && this.displayData.every(d => d.checked))
    const allUnChecked = validData.every(value => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = !allChecked && !allUnChecked;
  }

  //table edit row
  startEdit(item: any): void {
    this.editCache[item.id] = {
      edit: true,
      data: { ...item }
    };
  }

  updateEditCache(): void {
    this.listOfData?.forEach(item => {
      this.editCache[item.id] = {
        edit: false,
        data: { ...item }
      };
    });
  }

  cancelEditCache(id: string | number): void {
    const index = this.listOfData?.findIndex(item => item.id === id);
    this.editCache[id] = {
      data: { ...this.listOfData[index] },
      edit: false
    };
  }

  saveEditCache(id: string | number): void {
    const index = this.listOfData.findIndex(item => item.id === id);
    Object.assign(this.listOfData[index], this.editCache[id].data);
    this.editCache[id].edit = false;
  }
  addItem(data: any, url: string) {
    //add item then reload data
    // this.loadingService.showLoading();
    this.apiServices?.post(url, data)
    // .pipe(finalize(() => this.loadingService.hideLoading()))
    .subscribe((res: any) => {
      if(res?.code == 200 || !res){
        this.messageServices?.success('Thêm dữ liệu thành công.');
        this.onPageIndexChange(1);
      } else {
        this.messageServices?.error('Thêm dữ liệu thất bại.');
      }
    });
  }
  updateItem(data: any, url: string) {
    this.apiServices?.post(url, data)
    // .pipe(finalize(() => this.loadingService.hideLoading()))
    .subscribe((res: any) => {
      if(res?.code == 200 || res?.code === null){
        this.messageServices?.success('Sửa dữ liệu thành công.');
        this.onPageIndexChange(1);
      } else {
        this.messageServices?.error('Sửa dữ liệu thất bại.');
      }
    });
  }
  deleteData(data: any, urlApiDelete: string) {
    // this.loadingService.showLoading();
    this.apiServices?.post(urlApiDelete, data)
    // .pipe(finalize(() => this.loadingService.hideLoading()))
    .subscribe((res: any) => {
      if(res?.code == 200 || !res){
        this.messageServices?.success('Xóa dữ liệu thành công.');
        this.onPageIndexChange(1);
      } else {
        this.messageServices?.error('Xóa dữ liệu thất bại.');
      }
    });
  }
  deleteItems(dataDeleteChecked: any, urlApiDelete: string) {
    let payload = [];
    if (dataDeleteChecked?.length > 0) {
      payload = dataDeleteChecked?.map((x: any)=>x?.id);
      //action
      this.deleteData(payload, urlApiDelete);
      dataDeleteChecked = [];
    } else {
      this.messageServices?.error("Bạn cần chọn các tính năng cần xóa!")
    }
  }

  downloadFilePublic(file: any, filename: string): void {
    const blob = new Blob([file], { type: 'application/octet-stream' });
    var link = document.createElement('a');
    document.body.appendChild(link);
    link.href = window.URL.createObjectURL(blob)
    link.setAttribute('download', filename);
    link.click();
    document.body.removeChild(link);
  }
}
